import { axiosClient } from '@nx-frontend/shared/api';

interface ClientSendWorkspaceEventParams {
  name: string;
  payload?: { [key: string]: unknown };
}

export async function clientSendWorkspaceEvent({ name, payload }: ClientSendWorkspaceEventParams) {
  await axiosClient.post(`/v2/api/workspace-events`, {
    name,
    payload,
  });
}
